import React from "react";
import Aside from "../../Components/aside";
import MaybeFulltextComponent from "../../Components/maybeFulltextComponent";
import TopBar from "../../Components/topBar";
import { SnackbarProvider } from "notistack";
const MaybeFulltextPage = () => {
  return (
    <SnackbarProvider>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <MaybeFulltextComponent />
        </div>
      </div>
    </SnackbarProvider>
  );
};

export default MaybeFulltextPage;
